exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".video{position:relative;display:inline-block;color:#fff;font-family:Helvetica;background-color:#000;-webkit-font-smoothing:antialiased;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.video:focus{outline:thin dotted}.video__controls{position:absolute;bottom:0;left:0;right:0;opacity:0;transition:opacity .2s ease-in}.video--focused .video__controls,.video:hover .video__controls{opacity:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/react-html5video/src/components/video/video.css
// module id = 1381
// module chunks = 0